import { Component, OnInit } from '@angular/core';
import { blinkBorderAnimation } from 'src/app/animations/blink';
import { SBVDisplayType } from 'src/app/models/enums';
import { EventComponent } from '../../event/event.component';

@Component({
  selector: 'app-event-mobile',
  templateUrl: './event-mobile.component.html',
  styleUrls: ['./event-mobile.component.less'],
  animations: [blinkBorderAnimation]
})
export class EventMobileComponent extends EventComponent {
  public sbvDispalyTypeEnum = SBVDisplayType;
}
